import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-dark-bg text-white py-20 px-4 md:px-8" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <div className="flex items-center justify-center mb-6" data-id="element-118">
          <AlertTriangle className="w-12 h-12 text-brand-orange" data-id="element-119" />
        </div>
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-10 text-center uppercase" data-id="element-120">
          El problema no fue el{' '}
          <span className="text-brand-orange" data-id="element-121">asado del domingo</span>
        </h2>
        <div className="font-inter text-lg md:text-xl text-gray-300 space-y-6 leading-relaxed bg-dark-surface p-8 md:p-10 rounded-xl border border-gray-800 shadow-2xl" data-id="element-122">
          <p data-id="element-123">
            Fue el desayuno del lunes. Fue la insulina disparada a las 8 de la
            mañana con lo que "se supone que es sano". Fue el glucógeno que
            nunca se vació porque nunca le diste la señal correcta.
          </p>
          <p data-id="element-124">
            Tu cuerpo no está roto. Está esperando una instrucción diferente.
          </p>
          <p className="text-white font-semibold" data-id="element-125">
            Y esa instrucción no viene del gimnasio. Viene del orden en que
            comés, cuándo comés y qué hacés en los primeros 20 minutos de tu
            día.
          </p>
        </div>
      </div>
    </section>;
}